import { AIGeneratedField } from '@/redux/slices/formAIGenerationSlice'
import { CHOICES_FIELD_TYPES } from './buildField/buildField'

export default function isValidAIGeneratedField(field: AIGeneratedField) {
  if (!field.label?.trim()) return false
  if (CHOICES_FIELD_TYPES.includes(field.type) && !field.choices?.length) return false

  return true
}
